import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const BookTableForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: 1,
  });

  const [formErrors, setFormErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) errors.name = 'Name is required';
    if (!formData.email) errors.email = 'Email is required';
    if (!formData.phone) errors.phone = 'Phone number is required';
    if (!formData.date) errors.date = 'Date is required';
    if (!formData.time) errors.time = 'Time is required';
    if (formData.guests <= 0) errors.guests = 'Number of guests must be at least 1';
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length === 0) {
      // EmailJS Configuration
      const serviceID = 'service_qzz265r';
      const templateID = 'template_qupk19e';
      const userID = 'v9E9C4knB35xfzOEe';

      emailjs.send(serviceID, templateID, formData, userID)
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          setShowAlert(true); // Show the alert
          setFormData({ // Reset the form
            name: '',
            email: '',
            phone: '',
            date: '',
            time: '',
            guests: 1,
          });
          setFormErrors({}); // Clear any previous errors

          // Automatically hide the alert after 3 seconds
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        })
        .catch((error) => {
          console.log('FAILED...', error);
        });
    } else {
      setFormErrors(errors); // Set form errors if validation fails
    }
  };

  return (
    <div className="book-table-container">
      <h2 className="form-title">Reserve a Table</h2>
      <form className="book-table-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={formErrors.name ? 'error-input' : ''}
          />
          {formErrors.name && <span className="error-message">{formErrors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={formErrors.email ? 'error-input' : ''}
          />
          {formErrors.email && <span className="error-message">{formErrors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className={formErrors.phone ? 'error-input' : ''}
          />
          {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
        </div>

        <div className="form-row">
          <div className="form-group half-width">
            <label htmlFor="date">Date</label>
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className={formErrors.date ? 'error-input' : ''}
            />
            {formErrors.date && <span className="error-message">{formErrors.date}</span>}
          </div>

          <div className="form-group half-width">
            <label htmlFor="time">Time</label>
            <input
              type="time"
              id="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              className={formErrors.time ? 'error-input' : ''}
            />
            {formErrors.time && <span className="error-message">{formErrors.time}</span>}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="guests">Number of Guests</label>
          <input
            type="number"
            id="guests"
            name="guests"
            value={formData.guests}
            onChange={handleChange}
            min="1"
            className={formErrors.guests ? 'error-input' : ''}
          />
          {formErrors.guests && <span className="error-message">{formErrors.guests}</span>}
        </div>

        <button type="submit" className="submit-button">Book Table</button>
      </form>

      {showAlert && (
        <div className="alert-overlay">
          <div className="alert-box">
            <p>Table booked successfully! 🎉</p>
          </div>
        </div>
      )}

      <style jsx>{`
        .book-table-container {
          max-width: 400px;
          margin: 0 auto;
          padding: 15px;
          background-color: #f9f9f9;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .form-title {
          text-align: center;
          font-size: 1.8rem;
          color: #333;
          margin-bottom: 10px;
        }

        .book-table-form {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group label {
          font-size: 0.9rem;
          color: #333;
          margin-bottom: 3px;
        }

        .form-group input {
          padding: 8px;
          font-size: 0.9rem;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .form-group input.error-input {
          border-color: red;
        }

        .error-message {
          color: red;
          font-size: 0.8rem;
          margin-top: 3px;
        }

        .form-row {
          display: flex;
          gap: 10px;
        }

        .half-width {
          flex: 1;
        }

        .submit-button {
          background-color: #af1831;
          color: white;
          padding: 8px;
          border: none;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .submit-button:hover {
          background-color: #95152b;
        }

        .alert-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .alert-box {
          background: white;
          padding: 20px;
          border-radius: 8px;
          text-align: center;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default BookTableForm;